import {
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  useQueryStates,
} from "nuqs";

import { datePresets } from "./CallDashboardHelpers";

export function useCallDashboardFilters() {
  return useQueryStates({
    campaign_ids: parseAsArrayOf(parseAsInteger).withDefault([]),
    dial_session_ids: parseAsArrayOf(parseAsInteger).withDefault([]),
    disposition_ids: parseAsArrayOf(parseAsInteger).withDefault([]),
    agent_ids: parseAsArrayOf(parseAsInteger).withDefault([]),
    call_type: parseAsArrayOf(parseAsString).withDefault([]),
    duration_operator: parseAsString,
    disposition_operator: parseAsString,
    calls_per_day_operator: parseAsString,
    call_duration: parseAsString,
    calls_per_day: parseAsString,
    start_date: parseAsString
      .withDefault(datePresets.previous7days.start)
      .withOptions({
        clearOnDefault: false,
        history: "push",
      }),
    end_date: parseAsString
      .withDefault(datePresets.previous7days.end)
      .withOptions({
        clearOnDefault: false,
        history: "push",
      }),
  });
}
